import React, { useState } from 'react';

function ServiceBanners() {
  const [expandedService, setExpandedService] = useState(null);

  const services = [
    {
      id: 1,
      title: 'Sistema de Gestión de Medición',
      description: '',
      icon: '📏',
      subservices: [
        {
          id: 's1',
          name: 'Sistema de Gestión de Medicion',
          description: 'Contactanos para resolver tus dudas.',
          link: 'https://www.youtube.com/watch?v=9Kprgz7XT7Q',
        },
      ],
    },
    {
      id: 2,
      title: 'Anexo 30 y 31',
      description: 'Inspección y verificación de instalaciones.',
      icon: '⚡',
      subservices: [
        {
          id: 'a1',
          name: 'Áreas Contractuales',
          description: 'Gestión y supervisión de áreas contractuales.',
          link: 'https://asesoriapetrotec.com/services/',
        },
        {
          id: 'a2',
          name: 'Estaciones de Proceso',
          description: 'Mantenimiento y operación de estaciones de proceso.',
          link: 'https://asesoriapetrotec.com/services/',
        },
        {
          id: 'a3',
          name: 'Producción de Petrolíferos',
          description: 'Control y manejo en la producción de petrolíferos.',
          link: 'https://asesoriapetrotec.com/services/',
        },
        {
          id: 'a4',
          name: 'Terminales de Almacenamiento',
          description: 'Gestión de terminales y áreas de almacenamiento para usos propios.',
          link: 'https://asesoriapetrotec.com/services/',
        },
        {
          id: 'a5',
          name: 'Transporte o Distribución',
          description: 'Logística y transporte de petrolíferos.',
          link: 'https://asesoriapetrotec.com/services/',
        },
        {
          id: 'a6',
          name: 'Estaciones de Servicio',
          description: 'Operación y gestión de estaciones de servicio.',
          link: 'https://asesoriapetrotec.com/services/',
        },
      ],
    },
    {
      id: 3,
      title: 'NOM-005-ASEA-2016',
      description: 'Diseño, construcción y operación de instalaciones.',
      icon: '📋',
      subservices: [
        {
          id: 'n1',
          name: 'Etapa de diseño',
          description: 'Proceso de diseño de instalaciones.',
          link: 'https://asesoriapetrotec.com/services/',
        },
        {
          id: 'n2',
          name: 'Etapa de construcción',
          description: 'Construcción de infraestructura.',
          link: 'https://asesoriapetrotec.com/services/',
        },
        {
          id: 'n3',
          name: 'Etapa de operación y mantenimiento',
          description: 'Operación y mantenimiento continuos.',
          link: 'https://asesoriapetrotec.com/services/',
        },
      ],
    },
    {
      id: 4,
      title: 'NOM-016-CRE-2016',
      description: 'Verificación de calidad de combustibles.',
      icon: '🔍',
      subservices: [
        {
          id: 'c1',
          name: 'Muestreo y Análisis',
          description: 'Análisis detallado de calidad de combustibles.',
          link: 'https://asesoriapetrotec.com/services/',
        },
        {
          id: 'c2',
          name: 'Dictamen de especificaciones',
          description: 'Especificaciones detalladas de los petrolíferos.',
          link: 'https://asesoriapetrotec.com/services/',
        },
      ],
    },
    {
      id: 5,
      title: 'Laboratorio para calibración',
      description: 'Calibración de equipos de medición.',
      icon: '🔬',
      subservices: [
        {
          id: 'l1',
          name: 'Calibración en magnitud VOLUMEN',
          description: 'Tanques horizontales.',
          link: 'https://asesoriapetrotec.com/services/',
        },
        {
          id: 'l2',
          name: 'Calibración en magnitud LONGITUD',
          description: 'Sondas magnetostrictivas – medidores automáticos de nivel.',
          link: 'https://asesoriapetrotec.com/services/',
        },
        {
          id: 'l3',
          name: 'Calibración en magnitud TEMPERATURA',
          description: 'Sondas magnetostrictivas – medidores automáticos de temperatura.',
          link: 'https://asesoriapetrotec.com/services/',
        },
        {
          id: 'l4',
          name: 'Calibración de equipos de verificación manual',
          description: 'Medida volumétrica (Jarra patrón), Cinta petrolera con plomada y Termómetro electrónico portátil',
          link: 'https://asesoriapetrotec.com/services/',
        },
        {
          id: 'l5',
          name: 'Verificación de dispensarios',
          description: 'Verificación de dispensarios periódicas de acuerdo a la NOM-005-SCFI-2017',
          link: 'https://asesoriapetrotec.com/services/',
        },
      ],
    },
  ];

  const handleServiceClick = (serviceId) => {
    setExpandedService(expandedService === serviceId ? null : serviceId);
  };

  return (
    <div className="mt-12">
      <h2 className="text-2xl font-medium text-gray-900 mb-8 text-center">
        Nuestros Servicios
      </h2>
      <div className="space-y-6">
        {services.map((service) => (
          <div
            key={service.id}
            className="bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300"
          >
            <button
              type="button"
              className="w-full p-6 text-left"
              onClick={() => handleServiceClick(service.id)}
              aria-expanded={expandedService === service.id}
              aria-controls={`subservices-${service.id}`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <span className="text-4xl" role="img" aria-label={service.title}>
                    {service.icon}
                  </span>
                  <div>
                    <h3 className="text-lg font-medium text-gray-900">
                      {service.title}
                    </h3>
                    <p className="text-sm text-gray-600 mt-1">
                      {service.description}
                    </p>
                  </div>
                </div>
                <svg
                  className={`w-6 h-6 transform transition-transform duration-200 ${
                    expandedService === service.id ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </button>

            {/* Subservicios expandibles */}
            {expandedService === service.id && (
              <div
                className="border-t border-gray-100"
                id={`subservices-${service.id}`}
              >
                <div className="p-6 bg-gray-50">
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {service.subservices.map((subservice) => (
                      <a
                        key={subservice.id}
                        href={subservice.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`
                          bg-white p-4 rounded-lg shadow-sm hover:shadow-md
                          transition-all duration-200 transform hover:-translate-y-1 flex flex-col
                        `}
                      >
                        <h4 className="font-medium text-gray-900 mb-2">
                          {subservice.name}
                        </h4>
                        <p className="text-sm text-gray-600 flex-grow">
                          {subservice.description}
                        </p>
                        <div className="mt-4 text-blue-600 text-sm font-medium flex items-center">
                          Ver más
                          <svg
                            className="w-4 h-4 ml-1"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 5l7 7-7 7"
                            />
                          </svg>
                        </div>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-12 bg-[#0962b1] rounded-lg p-8 text-center">
        <h3 className="text-xl font-medium text-white mb-4">
          ¿Necesitas más información sobre nuestros servicios?
        </h3>
        <p className="text-gray-100 mb-6">
          Nuestro equipo está listo para ayudarte a elegir la mejor solución para tu negocio.
        </p>
        <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-white">
          <div className="flex items-center">
            <span className="text-2xl mr-2">📞</span>
            <span>(221) 15 96 130</span>
          </div>
          <div className="flex items-center">
            <span className="text-2xl mr-2">📱</span>
            <span>(221) 15 96 227</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceBanners;
